import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import md5 from 'md5';
import { useEffect } from 'react';
import { useContact } from '../Contact';
import { useMessage } from '../Message';
import { usePageModels } from '../PageModels';

const STORE_KEY_CLOSED_MESSAGES = 'gntc:closed-browser-detection-messages';

const generateRegexInstance = (stringRegex: string): RegExp => new RegExp(stringRegex, 'i');
const getStoreClosedMessageList = () =>
  JSON.parse(window.localStorage.getItem(STORE_KEY_CLOSED_MESSAGES) || '[]');

const isClosedMessage = (sessionEmail: string) => {
  const closedMessageList = getStoreClosedMessageList();
  return closedMessageList.includes(md5(sessionEmail));
};
const saveCloseMessage = (sessionEmail: string) => {
  const closedMessageList = getStoreClosedMessageList();
  window.localStorage.setItem(
    STORE_KEY_CLOSED_MESSAGES,
    JSON.stringify([...closedMessageList, md5(sessionEmail)]),
  );
};

const usePowerAppsBrowserDetection = () => {
  const { labels, config } = usePageModels();
  const { info } = useMessage();
  const { contactInfo } = useContact();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  const { powerApps: powerAppsLabels = {} } = labels;
  const { powerapps: powerAppsConfig = {} } = config;

  useEffect(() => {
    const { browserDetectionMessage, browserDetectionTitle, browserDetectionConfirmLabel } =
      powerAppsLabels;
    const { powerAppBrowserDetectionRegex, powerAppMobileBrowserDetectionRegex } = powerAppsConfig;

    const browserDetectionRegexString = isMobile
      ? powerAppMobileBrowserDetectionRegex
      : powerAppBrowserDetectionRegex;

    if (!browserDetectionRegexString && !isMobile) {
      console.error('A regex pattern must be provided to validate.');
      return;
    }

    const regex = generateRegexInstance(browserDetectionRegexString);
    const { userAgent } = navigator;
    let displayBrowserDetectionMessage;

    if (!browserDetectionRegexString && isMobile) {
      displayBrowserDetectionMessage = true;
    } else {
      displayBrowserDetectionMessage = !!userAgent.match(regex);
    }

    if (displayBrowserDetectionMessage && !isClosedMessage(contactInfo?.emailaddress1)) {
      info({
        title: browserDetectionTitle || '<Title>',
        message: browserDetectionMessage || '<Message>',
        duration: null,
        actionLabel: browserDetectionConfirmLabel || 'Ok',
        onAction: () => saveCloseMessage(contactInfo?.emailaddress1),
      });
    }
  }, [info, powerAppsLabels, powerAppsConfig, contactInfo?.emailaddress1, isMobile]);
};

export default usePowerAppsBrowserDetection;
